import { render, staticRenderFns } from "./ToursList.vue?vue&type=template&id=6a2fb403&"
import script from "./ToursList.vue?vue&type=script&lang=js&"
export * from "./ToursList.vue?vue&type=script&lang=js&"
import style0 from "./ToursList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports